/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 4 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation, untranslated } from "@i18n";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Accordion from "@CubeComponents/html/accordion/materialUiAccordian/index";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconComponent from "@CubeComponents/icons";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { useDispatch, useSelector } from "react-redux";
import { forwardRef, useEffect, useRef, useState } from "react";
import LinkBoqItems from "./linkBoqItems";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import { linkWBSSources, manageWBSItemSteps } from "@Features/commercial-shared/contracts/constant";
import CostDatabases from "@Features/portal-settings/components/PortalSetings/Estimates/CostDatabases/CostDatabases";
import _ from "lodash";
import { portalPurchaseUnitsUrl } from "@Services/dataManager";
import axiosWrapper from "@AxiosWrapper";
import type { GetPurchaseUnitsResponse } from "@ServerTypes/units/units.schema";
import type { WbsGetDetailsData, GetItemBreakUpDetailsResponse } from "@ServerTypes/contracts/contracts.schema";
import type { EstimateCurrency } from "@ServerTypes/estimates/estimates.schema";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import { showToastNotification } from "@Reducers/toastSlice";
import { SOMETHING_WENT_WRONG, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "@Services/constants";
import { itemListSources } from "@Actions/estimation";
import { EstimateDsrItemsGridNew } from "@Features/estimation";
import { useParams } from "react-router-dom";
import { contractWBSController, getItemBreakUpDetails } from "@Features/contracts/state/contracts.actions";
import NumericTextBoxComponent from "@CubeComponents/Mui_Form/NumericTextBoxComponent";
import { v4 as uuid } from "uuid";
import ItemBreakUpModal from "./itemBreakUpModal";
import InPlaceEditorComponent from "@CubeComponents/Mui_Form/InPlaceEditorComponent";
import {
  getContractCRUDPermission,
  getGridColumns,
  getTotal,
} from "@Features/commercial-shared/contracts/contractHelpers";
import LinkWBS from "./linkWBS";
import { ObjectId } from "bson";
import { getSymbolForNumber } from "@Services/utils/helpers";
import Text from "@CubeComponents/html/Text/Text";
import { Box, CircularProgress } from "@mui/material";
// import SlickGrid from "@CubeComponents/html/SlickGrid";
import { portalCreateRoot as createRoot } from "@CubeComponents/html/cellPortals";
import { Formatters } from "slickgrid-react";
import { RootState } from "@Reducers/index";
import SlickGrid from "@CubeComponents/html/SlickGrid1";

type WbsGridRow = NonNullable<WbsGetDetailsData["dataSource"]>[number];

interface WbsSelectedItem extends Omit<
  Partial<WbsGridRow>,
  "billedAmount" | "inspectedAmount" | "revisedAmount" | "usedAmount"
> {
  originalItemId?: string;
  parentContract?: string | null;
  availableAmount: number;
  billedAmount: number;
  inspectedAmount: number;
  revisedAmount: number;
  usedAmount: number;
}

interface ShowDetailsSideBarState {
  status?: boolean;
  selectedItem?: Record<string, unknown>;
  source?: string;
}

interface WbsChangeOrderState {
  isEnabled: boolean;
}

interface IdMapper {
  id: string;
  parentId: string;
}

interface WBSItemDetailsProps {
  showDetailsSideBar?: ShowDetailsSideBarState;
  manageItemSuccessCallBack?: () => void;
  source?: string;
  showOnlyGrid?: boolean;
  treeDataSource?: WbsGridRow[];
  getCustomData?: (data: unknown) => void;
  isCurrentUserAllowed?: boolean;
  showInfoColumn?: boolean;
  infoClickCallBack?: (args: unknown) => void;
  idMapper?: IdMapper;
  // Callers (contractWBS.tsx, etc.) pass a React state dispatcher whose state type
  // (DetailsSideBarState) is defined locally per-file and is not structurally
  // interchangeable with this file's ShowDetailsSideBarState, so this stays loose.
  setShowDetailsSideBar?: (value: any) => void;
  changeOrderState?: WbsChangeOrderState;
  allowCheckBoxSelection?: boolean;
  manageLinkBtnState?: (enabled: boolean) => void;
  showQuantityInputBox?: boolean;
  showRemarksColumn?: boolean;
  updateAmountInWBSGrid?: (originalItemId: string | undefined, amount: number) => void;
}

interface ManageItemModalState {
  status: boolean;
  step: string | null;
  metaData: {
    isNextEnabled: boolean;
    isLinkCDBItemsBtnEnabled: boolean;
    isAddParentWbsItemsBtnEnabled: boolean;
  };
}

type WbsGridRowLoose = WbsGridRow & Record<string, unknown>;

interface SelectedCDB {
  _id?: string;
  name?: string;
  currency?: EstimateCurrency;
  costDBversionId?: string;
}

interface ToolBarBtnState {
  add: boolean;
  add_child: boolean;
  add_top?: boolean;
  edit: boolean;
  delete: boolean;
  changeType: boolean;
  attachToWBSItem: boolean;
  properties: boolean;
  update: boolean;
  cancel: boolean;
  loading: Record<string, boolean>;
}

const WBSItemDetails = forwardRef(
  (
    {
      showDetailsSideBar = {},
      manageItemSuccessCallBack,
      source = "WBSView",
      showOnlyGrid = false,
      treeDataSource = [],
      getCustomData,
      isCurrentUserAllowed = true,
      showInfoColumn = false,
      infoClickCallBack,
      idMapper = { id: "itemId", parentId: "parentId" },
      setShowDetailsSideBar,
      changeOrderState = { isEnabled: false },
      allowCheckBoxSelection = true,
      manageLinkBtnState,
      showQuantityInputBox = false,
      showRemarksColumn = false,
      updateAmountInWBSGrid,
    }: WBSItemDetailsProps,
    ref: React.ForwardedRef<unknown>,
  ) => {
    const {
      _id,
      code,
      description,
      billedAmount,
      inspectedAmount,
      usedAmount,
      revisedAmount,
      originalItemId,
      parentContract,
      availableAmount,
    } = (showDetailsSideBar.selectedItem || {}) as unknown as WbsSelectedItem;

    const initialManageObj = {
      status: false,
      step: null,
      metaData: {
        isNextEnabled: false,
        isLinkCDBItemsBtnEnabled: false,
        isAddParentWbsItemsBtnEnabled: false,
      },
    };
    const { t } = useTranslation();
    const innerRef = useRef<any>(null);
    const attachedItemRef: any = ref || innerRef;
    const dropDownRef: any = useRef<any>(null);
    const params = useParams();
    const budgetAmountRef: any = useRef<any>(null);
    const dispatch = useDispatch();
    const CDBItemsRef: any = useRef<any>(null);
    const purchaseUnitDataSourceRef = useRef<GetPurchaseUnitsResponse["result"]>([]);
    const currencyDetails = useSelector((state: RootState) => state.currencyDetails);
    const portalData = useSelector((state: RootState) => state.portalData);
    const contractDetails = useSelector((state: RootState) => state.contractDetails);
    const [showBoqItemLinkingModal, setShowBoqItemLinkingModal] = useState(false);
    const [showManageItemModal, setShowManageItemModal] = useState<ManageItemModalState>(initialManageObj);
    const [selectedCDB, setSelectedCDB] = useState<SelectedCDB>({});
    const [wbsItemDetail, setWbsItemDetail] = useState<NonNullable<WbsGetDetailsData["itemDetail"]>>({
      revisedAmount,
      availableAmount,
    } as NonNullable<WbsGetDetailsData["itemDetail"]>);
    const [disabledRows, setDisabledRows] = useState<string[]>([]);
    const [parentWbsLinkedItems, setParentWbsLinkedItems] = useState<NonNullable<WbsGetDetailsData["dataSource"]>>([]);
    const [totalAmountLinked, setTotalAmountLinked] = useState(revisedAmount);
    const [deletedRows, setDeletedRows] = useState<string[]>([]);
    const [newParentIds, setNewParentIds] = useState<string[]>([]);
    const [gridDataSource, setGridDataSource] = useState<NonNullable<WbsGetDetailsData["dataSource"]>>([]);
    const [showGridLoader, setShowGridLoader] = useState<boolean>(false);
    const [showBoqItemBreakUp, setShowBoqItemBreakUp] = useState<{
      status: boolean;
      itemDetail: GetItemBreakUpDetailsResponse | { contractForms: never[]; contracts: never[] };
    }>({
      status: false,
      itemDetail: {
        contractForms: [],
        contracts: [],
      },
    });
    const [columnDefinitions, setColumnDefinitions] = useState<any>([]);
    const [editBudgetAmount, setEditBudgetAmount] = useState(false);
    const [showAssignWBSModal, setShowAssignWBSModal] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState({
      status: false,
      source: "",
    });
    const [selectedItemsInMainGrid, setSelectedItemsInMainGrid] = useState([]);
    const [typeOfItemAdded, setTypeOfItemAdded] = useState<any>({ type: "", parentData: {} });

    const isRustomjeePortal = portalData?.frontendUrl?.includes("rustomjee") || false;
    const accordionMapper = ["Details", "Boq Items"];
    const contractId = params.contractId ?? "";
    const wbsBoqItemsCustomQuantity = useRef<Record<string, number>>({});

    const [toolBarBtnState, setToolBarBtnState] = useState<ToolBarBtnState>({
      add: true,
      add_child: false,
      edit: false,
      delete: false,
      changeType: false,
      attachToWBSItem: false,
      properties: false,
      update: false,
      cancel: false,
      loading: {},
    });
    const [editingRowValue, setEditingRowValue] = useState<any>({});
    const [isWrapTextActive, setIsWrapTextActive] = useState(false);
    const editModeRef = useRef<any>(null);

    useEffect(() => {
      editModeRef.current = editingRowValue;
    }, [editingRowValue]);

    useEffect(() => {
      let totalAmount = gridDataSource.reduce(
        (accumulator: number, object) => accumulator + (object.hasChild ? 0 : (object.revisedAmount ?? 0)),
        0,
      );

      totalAmount = Number(totalAmount.toFixed(2));
      setTotalAmountLinked(totalAmount);

      let dataSource = gridDataSource;
      if (showManageItemModal.step === manageWBSItemSteps.showParentWBSItems) {
        dataSource = parentWbsLinkedItems;
      }
      const disabledItemIds: any = dataSource
        ?.filter(
          (item: any) =>
            item.isAlreadyAddedInThisForm || item.isAlreadyAddedInThisContract || item.isAlreadyLinkedWithThisWBSItem,
        )
        .map((item: any) => item?.[idMapper.id]);
      setDisabledRows([...disabledItemIds]);
    }, [gridDataSource, parentWbsLinkedItems, showManageItemModal.step, idMapper.id]);

    useEffect(() => {
      if (!getContractCRUDPermission(contractDetails, changeOrderState) && dropDownRef.current) {
        dropDownRef.current.disabled = true;
      }
    }, [contractDetails]);

    const fetchPurchaseUnits = async () => {
      const response = await axiosWrapper.post<GetPurchaseUnitsResponse>(portalPurchaseUnitsUrl, {
        value: { params: {} },
      });
      if (response.data?.result) {
        purchaseUnitDataSourceRef.current = response.data.result;
      }
    };
    useEffect(() => {
      fetchPurchaseUnits();
    }, []);

    const loadDetailsData = async () => {
      setShowGridLoader(true);
      if (source == "BoqView") {
        const res = await contractWBSController({
          value: {
            viewType: "BoqView",
            contractId: contractId,
            contractVersionId: contractDetails.versionId,
          },
        });
        if (res.data.status) {
          // const data = modifyDataSource(res.data.result);
          setGridDataSource(() => [...(res.data.result ?? [])]);
        }
      } else if (source == "WBSView") {
        const res = await contractWBSController({
          action: "getWBSItemDetails",
          wbsOriginalItemId: originalItemId!,
          contractId: contractId,
          contractVersionId: contractDetails.versionId,
        });
        if (res.data.status) {
          const wbsData = res.data.data as WbsGetDetailsData;
          setWbsItemDetail(() => ({ ...wbsData.itemDetail }) as NonNullable<WbsGetDetailsData["itemDetail"]>);
          setGridDataSource(() => [...(wbsData.dataSource ?? [])]);
        }
      } else if (source == "FormView") {
        setGridDataSource(() => [...treeDataSource]);
      }
      setShowGridLoader(false);
    };

    useEffect(() => {
      if (source == "FormView") {
        setGridDataSource(() => [...treeDataSource]);
      }
    }, [treeDataSource.length]);

    useEffect(() => {
      loadDetailsData();
    }, []);

    const cancelEditRecord = (removeRecord = false) => {
      if (removeRecord) {
        attachedItemRef.current.removeRecord(editingRowValue.position, editingRowValue);
      }
      setEditingRowValue({});
      attachedItemRef.current.slickGrid.setSelectedRows([]);
      setToolBarBtnState((prev) => ({
        ...prev,
        add_top: true,
        add_child: false,
        edit: false,
        delete: false,
        update: false,
        cancel: false,
        add: true,
        changeType: false,
        attachToWBSItem: false,
        properties: false,
        loading: {},
      }));
    };

    const showErrorToast = (content: any) => {
      dispatch(
        showToastNotification({
          content,
          type: TOAST_TYPE_ERROR,
        }),
      );
    };

    const sectionHeader = (data: string) => {
      let IconName = "";
      if (data === "Details") {
        IconName = "details";
      } else if (data === "Boq Items") {
        IconName = "BoqItems";
      }
      return (
        <div className="flex items-center gap-1">
          <IconComponent name={IconName} width="1.5rem" height="1.5rem" />
          {data}
        </div>
      );
    };
    const hideBoqItemsLinkingModal = () => {
      cancelManageItem();
    };

    const manageItemHandler = () => {
      setShowManageItemModal((prev) => ({
        ...prev,
        status: true,
        step: manageWBSItemSteps.showLinkedItems,
      }));
      loadDetailsData();
    };

    const detailSectionMapper = [
      {
        name: `Budgeted(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.revisedAmount,
        allow: true,
      },
      {
        name: `Alloted to Boq Items(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail?.boqItemsAmount?.toFixed(2) || <CircularProgress size={20} />,
        allow: true,
      },
      {
        name: `Assigned to Nested Contracts/Forms(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.revisedAmount - wbsItemDetail.availableAmount,
        allow: true,
      },
      {
        name: `Change order(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.changeOrderAmount,
        allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
      },
      {
        name: `Revised(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.revisedAmount,
        allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
      },
      ...(isRustomjeePortal
        ? []
        : [
            {
              name: `Used(${currencyDetails.symbolDetail?.name}) :`,
              value: usedAmount,
              allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
            },
          ]),
      {
        name: `Remaining(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.remainingAmount,
        allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
      },
      ...(isRustomjeePortal
        ? [
            {
              name: `Work Done(${currencyDetails.symbolDetail?.name}) :`,
              value: inspectedAmount,
              allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
            },
          ]
        : [
            {
              name: `Inspected(${currencyDetails.symbolDetail?.name}) :`,
              value: wbsItemDetail.inspectedAmount,
              allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
            },
          ]),
      {
        name: `Billed(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.billedAmount,
        allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
      },
      {
        name: `paid(${currencyDetails.symbolDetail?.name}) :`,
        value: wbsItemDetail.paidAmount || 0,
        allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
      },

      ...(isRustomjeePortal
        ? [
            {
              name: `Un-Billed(${currencyDetails.symbolDetail?.name}) :`,
              value: inspectedAmount - billedAmount,
              allow: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
            },
          ]
        : []),

      // { name: `paid(${currencyDetails.symbolDetail?.name}) :`, value: paidAmount, allow: (contractDetails.isLocked || contractDetails.isAnyOneChildContractLocked) },
    ];

    const handleBudgetAmountEditClick = async (args: { value: string | number }) => {
      const amount = Number(String(args.value).replace(/,/g, ""));
      const res = await contractWBSController({
        action: "manageItemsBudgetAmount",
        wbsItemId: originalItemId!,
        contractId: contractId,
        budgetAmount: amount,
      });
      if (res.data.status) {
        loadDetailsData();
        updateAmountInWBSGrid?.(originalItemId, amount);
      }
    };

    const sectionContent = (data: string) => {
      if (data === "Details") {
        const validationRule: any = {
          Number: {
            required: true,
            min: [
              wbsItemDetail.boqItemsAmount > wbsItemDetail.revisedAmount - wbsItemDetail.availableAmount
                ? wbsItemDetail.boqItemsAmount
                : wbsItemDetail.revisedAmount - wbsItemDetail.availableAmount,
              "Amount cannot be lower than what is allotted to BOQ items, or assigned to nested Contracts or used in forms",
            ],
          },
        };
        if (parentContract) {
          validationRule.Number.max = [
            wbsItemDetail.availableAmountInParent + wbsItemDetail.revisedAmount,
            "Amount cannot be greater than what is available in parent wbs item",
          ];
        }
        return (
          <div className="flex flex-col gap-8">
            {detailSectionMapper.map(
              (data, index) =>
                data.allow && (
                  <div key={index} className="flex">
                    <span className="w-1/2">{data.name}</span>
                    <span className="w-1/2 flex justify-between items-center">
                      {index == 0 && editBudgetAmount ? (
                        <InPlaceEditorComponent
                          mode="Inline"
                          ref={budgetAmountRef}
                          model={{ placeholder: "Enter Budget Amount", min: 0 }}
                          value={data.value as string | number}
                          type="Numeric"
                          actionBegin={handleBudgetAmountEditClick}
                          enableEditMode
                          name="Number"
                          id="budgetAmountId"
                          validationRules={validationRule}
                          cancelClick={() => setEditBudgetAmount(false)}
                          endEdit={() => setEditBudgetAmount(false)}
                          change={() => budgetAmountRef.current.validate()}
                        />
                      ) : (
                        <span>{data.value}</span>
                      )}
                      {index == 0 &&
                        !editBudgetAmount &&
                        getContractCRUDPermission(contractDetails, changeOrderState) && (
                          <IconComponent
                            onClick={() => setEditBudgetAmount(true)}
                            className="cursor-pointer"
                            name="editProfile"
                            width="1.25rem"
                            height="1.25rem"
                          />
                        )}
                    </span>
                  </div>
                ),
            )}
          </div>
        );
      }
      if (data === "Boq Items") {
        return (
          <div className="flex flex-col gap-5">
            <span>
              <ButtonComponent onClick={manageItemHandler} buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
                <Text>{t("Manage Items")}</Text>
              </ButtonComponent>
            </span>
            <span className="flex">
              <span className="flex-1">{"Items Added : "}</span>
              <span className="flex-2">{gridDataSource.length}</span>
            </span>
          </div>
        );
      }
    };

    const getItemDataAcc = () => (
      <div className="flex flex-col w-full h-full gap-3">
        {accordionMapper.map((data, index) => (
          <div key={index} className="border-b-2 border-button_light pb-3">
            <Accordion key={_id} defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>{sectionHeader(data)}</AccordionSummary>
              <AccordionDetails>{sectionContent(data)}</AccordionDetails>
            </Accordion>
          </div>
        ))}
      </div>
    );

    const handleRemoveItemsFromBoqView = async (args: string[]) => {
      const res = await contractWBSController({
        action: "manageBoqViewItems",
        actionCase: "delete",
        contractId,
        data: args,
      });
      if (res.data.status) {
        loadDetailsData();
      } else {
        showErrorToast(res.data.errorMessage);
      }
    };

    const handleTypeChange = async (data: any) => {
      const res = await contractWBSController({
        action: "manageBoqViewItems",
        actionCase: "changeType",
        contractId,
        data,
      });
      if (res.data.status) {
        loadDetailsData();
      } else {
        showErrorToast(res.data.errorMessage);
      }
    };
    const toolbarClickHandler = (clickedBtn: string) => {
      const totalRowsSelected = attachedItemRef.current?.dataView?.getAllSelectedItems();
      setSelectedItemsInMainGrid(totalRowsSelected);
      if (clickedBtn === "edit") {
        const rowData = totalRowsSelected[0];
        if (rowData.hasChild && rowData.type != "MANUAL") {
          dispatch(
            showToastNotification({
              content: t("Only manual items can be edited here"),
              type: TOAST_TYPE_WARNING,
            }),
          );
          return;
        } else if (rowData.isPresentInLockedChildContract) {
          dispatch(
            showToastNotification({
              content: t("Selected item can no longer be edited as it a part of a locked child contract"),
              type: TOAST_TYPE_WARNING,
            }),
          );
          return;
        } else if (source == "BoqView" && rowData.wbsItems.length && rowData.type != "MANUAL") {
          dispatch(
            showToastNotification({
              content: t("Only manual items can be edited here"),
              type: TOAST_TYPE_WARNING,
            }),
          );
          return;
        }
        setToolBarBtnState((prev) => ({
          ...prev,
          add: false,
          add_child: false,
          properties: false,
          changeType: false,
          attachToWBSItem: false,
          edit: false,
          delete: false,
          update: true,
          cancel: true,
        }));
        const currentRecord = totalRowsSelected[0];
        setEditingRowValue({
          ...currentRecord,
          action: "edit",
        });
      } else if (clickedBtn === "delete") {
        const selectedRows = attachedItemRef.current?.dataView?.getAllSelectedItems();

        const allItemIdsToBeRemoved: any = [];
        let isChildContractLocked = false;
        let isAddedInForms = false;

        selectedRows.map((item: any) => {
          if (item.isPresentInLockedChildContract) {
            isChildContractLocked = true;
          }
          if (item.isAddedInForms) {
            isAddedInForms = true;
          }
        });

        if (isChildContractLocked) {
          showErrorToast(
            "Some of the selected items cannot be removed because they have already been added to a locked child contract.",
          );
        } else if (isAddedInForms) {
          showErrorToast("Some of the selected items cannot be removed because they have already been added to forms");
        } else {
          const dataSource = attachedItemRef.current.dataView.items;
          selectedRows.map((item: any) => {
            allItemIdsToBeRemoved.push(item.itemId);

            if (item.parentsList) {
              item.parentsList.map((pItem: any) => {
                if (pItem.itemId != "0") {
                  allItemIdsToBeRemoved.push(pItem.itemId);
                }
              });
            }

            dataSource.map((data: any) => {
              if (data.parentsList) {
                const pData = data.parentsList.find((pItem: any) => pItem.itemId == item.itemId);
                if (pData) {
                  allItemIdsToBeRemoved.push(data.itemId);
                }
              }
            });
          });
          dataSource.map((item: any) => {
            if (!allItemIdsToBeRemoved.includes(item.itemId) && item.parentsList) {
              item.parentsList.map((pItem: any) => {
                const index = allItemIdsToBeRemoved.indexOf(pItem.itemId);
                if (index !== -1) {
                  allItemIdsToBeRemoved.splice(index, 1);
                }
              });
            }
          });

          if (source == "WBSView") {
            setGridDataSource((prev) => prev.filter((item) => !allItemIdsToBeRemoved.includes(item.itemId)));
            setDeletedRows((prev) => [...prev, ...allItemIdsToBeRemoved]);
          } else if (source == "BoqView") {
            const validItemIdsToBeRemoved = allItemIdsToBeRemoved.filter(Boolean);
            handleRemoveItemsFromBoqView(validItemIdsToBeRemoved);
          }
        }
      } else if (clickedBtn === "changeType") {
        const selectedRow = attachedItemRef.current?.dataView?.getAllSelectedItems();
        const selectedItemIds = selectedRow.map((item: any) => item.itemId);
        const dataSource = attachedItemRef.current.dataView.items;
        let isAnyOneChildContractLocked = false;
        let areAllItemOfNonManualType = true;
        selectedRow.map((item: any) => {
          if (item.type == "MANUAL") {
            areAllItemOfNonManualType = false;
          }
          if (item.isPresentInLockedChildContract) {
            isAnyOneChildContractLocked = true;
          }
        });
        if (isAnyOneChildContractLocked) {
          dispatch(
            showToastNotification({
              content: t(
                "Selected item's type cannot be changed because it has already been added to a locked child contract.",
              ),
              type: TOAST_TYPE_WARNING,
            }),
          );
        } else if (areAllItemOfNonManualType) {
          const changeTypeItemIds: any = [];
          const newData = [...dataSource].map((item: any) => {
            if (selectedItemIds.includes(item.itemId)) {
              if (item.wbsItems?.length) {
                item.wbsItems.map((wbs: any) => {
                  changeTypeItemIds.push({
                    itemId: item.itemId,
                    wbsItemId: wbs._id,
                  });
                });
              } else {
                changeTypeItemIds.push({
                  itemId: item.itemId,
                  wbsItemId: null,
                });
              }
              delete item.code;
              delete item.costDatabaseId;
              delete item.costDatabaseVersionId;
              delete item.rateAnalysis;
              delete item.status;
              delete item.isPresentInLockedChildContract;

              delete item.estimateId;
              delete item.estimateVersionId;
              delete item.measurementUnit;
              delete item.status;
              delete item.availableQuantityInParentEstimate;
              item.type = "MANUAL";
              item.changeType = true;
            }
            return item;
          });

          if (source == "WBSView") {
            setGridDataSource(() => newData);
          } else if (source == "BoqView") {
            handleTypeChange(changeTypeItemIds);
          }
        }
      } else if (clickedBtn === "estimateItem") {
        if (_.get(contractDetails, "linkedEstimateVersion.versionId")) {
          setShowManageItemModal((prev) => ({ ...prev, status: false }));
          setShowBoqItemLinkingModal(true);
          setTypeOfItemAdded({ type: "Parent" });
        } else {
          dispatch(
            showToastNotification({
              content: t(
                "No Estimate have been linked to the contract first link an estimate then try to attach boq items",
              ),
              type: TOAST_TYPE_WARNING,
            }),
          );
        }
      } else if (clickedBtn === "parentBoqItems") {
        handleAddItemFromParent();
      } else if (clickedBtn === "costDatabaseItem") {
        setShowManageItemModal((prev) => ({
          ...prev,
          status: true,
          step: manageWBSItemSteps.showCDB,
        }));
        setTypeOfItemAdded({ type: "Parent" });
      } else if (clickedBtn === "manualItem") {
        setTypeOfItemAdded({ type: "Parent" });
        const rowToAdd = {
          action: "add",
          id: 1,
          position: 0,
          itemLevel: 0,
          serial: "",
          type: "MANUAL",
          description: "",
          code: "",
          HSN_SAC: "",
          purchaseUnit: {
            name: "",
          },
          rate: 0,
          quantity: 0,
          amount: 0,
          changeOrderQuantity: 0,
          changeOrderAmount: 0,
          revisedQuantity: 0,
          revisedAmount: 0,
          usedAmount: 0,
          usedQuantity: 0,
          inspectedQuantity: 0,
          inspectedAmount: 0,
          billedQuantity: 0,
          billedAmount: 0,
          availableQuantity: 0,
          wbsItems: [],
          parentId: null,
          hasChild: false,
          parentsList: [],
          __hasChildren: false,
          __used: true,
        };
        attachedItemRef.current.addRecord(rowToAdd, 0);
        setToolBarBtnState((prev) => ({
          ...prev,
          add: false,
          add_child: false,
          properties: false,
          attachToWBSItem: false,
          changeType: false,
          edit: false,
          delete: false,
          update: true,
          cancel: true,
        }));
        setEditingRowValue(rowToAdd);
      } else if (clickedBtn === "attachToWBSItem") {
        let isAnyChildItemSelected = false;
        const selectedItem = attachedItemRef.current?.dataView?.getAllSelectedItems();

        selectedItem.map((item: any) => {
          if (item.parentId) {
            isAnyChildItemSelected = true;
          }
        });
        if (isAnyChildItemSelected) {
          dispatch(
            showToastNotification({
              content: t("Only Parent Level Items can be assigned to WBS Item"),
              type: TOAST_TYPE_WARNING,
            }),
          );
        } else {
          setShowAssignWBSModal(true);
        }
      } else if (clickedBtn === "properties") {
        const selectedRecord = attachedItemRef.current?.dataView?.getAllSelectedItems()[0];
        setShowDetailsSideBar?.((prev: ShowDetailsSideBarState) => {
          if (prev.status) {
            return {
              status: false,
              selectedItem: {},
            };
          }
          return {
            status: true,
            selectedItem: selectedRecord,
            source: selectedRecord.hasChild ? "parentItemsField" : "childItemsField",
          };
        });
      } else if (
        clickedBtn === "childManualItem" ||
        clickedBtn === "childCostDatabaseItem" ||
        clickedBtn == "childEstimateItem"
      ) {
        const selectedRow = attachedItemRef.current?.dataView?.getAllSelectedItems()[0] || {};
        if (selectedRow?.wbsItems?.length > 1) {
          dispatch(
            showToastNotification({
              content: t("Adding child to an item associated with multiple WBS items cannnot be done from here"),
              type: TOAST_TYPE_WARNING,
            }),
          );
          return;
        }
        if (clickedBtn === "childCostDatabaseItem") {
          setTypeOfItemAdded({ type: "Child", parentData: selectedRow });
          setToolBarBtnState((prev) => ({
            ...prev,
            add: false,
            add_child: false,
            properties: false,
            changeType: false,
            attachToWBSItem: false,
            edit: false,
            delete: false,
            update: true,
            cancel: true,
          }));
          setShowManageItemModal((prev) => ({
            ...prev,
            status: true,
            step: manageWBSItemSteps.showCDB,
          }));
        } else if (clickedBtn == "childEstimateItem") {
          if (_.get(contractDetails, "linkedEstimateVersion.versionId")) {
            setShowManageItemModal((prev) => ({ ...prev, status: false }));
            setShowBoqItemLinkingModal(true);
            setTypeOfItemAdded({ type: "Child", parentData: selectedRow });
            setToolBarBtnState((prev) => ({
              ...prev,
              add: false,
              add_child: false,
              properties: false,
              changeType: false,
              attachToWBSItem: false,
              edit: false,
              delete: false,
              update: true,
              cancel: true,
            }));
          } else {
            dispatch(
              showToastNotification({
                content: t(
                  "No Estimate have been linked to the contract first link an estimate then try to attach boq items",
                ),
                type: TOAST_TYPE_WARNING,
              }),
            );
          }
        } else {
          setTypeOfItemAdded({ type: "Child", parentData: selectedRow });
          setToolBarBtnState((prev) => ({
            ...prev,
            add: false,
            add_child: false,
            properties: false,
            attachToWBSItem: false,
            changeType: false,
            edit: false,
            delete: false,
            update: true,
            cancel: true,
          }));
          if (totalRowsSelected[0]?.itemId) {
            const expandIds =
              totalRowsSelected[0]?.parentsList?.map((item) => ({ itemId: item.itemId, isCollapsed: false })) ?? [];
            attachedItemRef.current.treeDataService.dynamicallyToggleItemState(expandIds);
          }
          const rowToAdd: any = {
            action: "add",
            id: 1,
            position: 0,
            itemLevel: 0,
            serial: "",
            type: "MANUAL",
            description: "",
            code: "",
            HSN_SAC: "",
            purchaseUnit: {
              name: "",
            },
            rate: 0,
            quantity: 0,
            amount: 0,
            changeOrderQuantity: 0,
            changeOrderAmount: 0,
            revisedQuantity: 0,
            revisedAmount: 0,
            usedAmount: 0,
            usedQuantity: 0,
            inspectedQuantity: 0,
            inspectedAmount: 0,
            billedQuantity: 0,
            billedAmount: 0,
            availableQuantity: 0,
            wbsItems: [],
            parentId: null,
            hasChild: false,
            __hasChildren: false,
            __used: true,
            parentsList: [],
          };
          const position = attachedItemRef.current.slickGrid.getSelectedRows()[0];
          const parentItem: any = attachedItemRef.current?.dataView?.getAllSelectedItems()[0];
          rowToAdd.position = position + 1;
          rowToAdd.parentId = parentItem.itemId;
          rowToAdd.parentsList = [
            {
              type: parentItem.type,
              itemId: parentItem.itemId,
            },
            ...(parentItem.parentsList ?? []),
          ];
          rowToAdd.itemLevel = parentItem.itemLevel + 1;
          attachedItemRef.current.addRecord(rowToAdd, rowToAdd.position);
          setEditingRowValue(rowToAdd);
        }
      } else if (clickedBtn === "expandAll") {
        attachedItemRef.current?.treeDataService.toggleTreeDataCollapse(false);
      } else if (clickedBtn === "collapseAll") {
        attachedItemRef.current?.treeDataService.toggleTreeDataCollapse(true);
      } else if (clickedBtn === "cancel") {
        cancelEditRecord(editingRowValue.action == "add");
      } else if (clickedBtn === "update") {
        if (editingRowValue.action == "add") {
          setToolBarBtnState((prev) => ({
            ...prev,
            loading: {
              cancel: true,
              update: true,
            },
          }));
          addManualItem(editingRowValue);
        } else {
          const dataSource = attachedItemRef.current.dataView.items;
          const newQuantity = changeOrderState.isEnabled ? editingRowValue.revisedQuantity : editingRowValue.quantity;
          const previousData = totalRowsSelected[0];
          const prevQuantity = previousData.revisedQuantity ?? 0;
          let editedItem: any = {};
          const newData = [...dataSource].map((item: any) => {
            if (item.itemId == editingRowValue.itemId) {
              item.quantity = newQuantity ? Number(newQuantity) : 0;
              item.revisedQuantity = newQuantity ? Number(newQuantity) : 0;
              item.revisedAmount = (newQuantity && Number(newQuantity) * editingRowValue.rate) || 0;
              item.remainingQuantity = newQuantity ? Number(newQuantity) - Number(item.usedQuantity ?? 0) : 0;
              item.remainingAmount = newQuantity
                ? Number(newQuantity - (item.usedQuantity ?? 0)) * Number(editingRowValue.rate)
                : 0;
              item.amount = (newQuantity && Number(newQuantity) * editingRowValue.rate) || 0;
              item.availableQuantity = (item.availableQuantity ?? 0) + (newQuantity - prevQuantity);
              item.HSN_SAC = editingRowValue.HSN_SAC;

              if (changeOrderState.isEnabled) {
                item.quantity = previousData.quantity;
                item.amount = previousData.amount;
                item.changeOrderQuantity = newQuantity - previousData.quantity;
                item.changeOrderAmount = (newQuantity - previousData.quantity) * editingRowValue.rate;
                item.isUpdatedThroughChangeOrder = true;
              }

              if (item.type == "ESTIMATE" && item.parentContract == null) {
                item.availableQuantityInParentEstimate =
                  item.availableQuantityInParent -
                  ((newQuantity ? Number(newQuantity) : 0) - (prevQuantity ? Number(prevQuantity) : 0));
              }
              if (item.type == "MANUAL") {
                if (!item.hasChild) {
                  item.rate = editingRowValue.rate;
                  item.purchaseUnit = editingRowValue.purchaseUnit;
                }
                item.description = editingRowValue.description;
              }
              editedItem = item;
            }
            return {
              ...item,
            };
          });
          if (source == "WBSView") {
            cancelEditRecord();
            setGridDataSource(() => [...newData]);
          } else if (source == "BoqView") {
            addItemsInBoqView({
              data: [editedItem],
              wbsItemId: editedItem.wbsItems[0]?._id,
            });
          }
        }
      }
    };
    const cancelManageItem = () => {
      setShowManageItemModal((prev) => ({
        ...prev,
        status: false,
        step: null,
        isNextEnabled: false,
        isLinkCDBItemsBtnEnabled: false,
        isAddParentWbsItemsBtnEnabled: false,
      }));
      setSelectedCDB({});
      setDeletedRows([]);
      setNewParentIds([]);
      setToolBarBtnState({
        add: true,
        add_child: false,
        edit: false,
        delete: false,
        changeType: false,
        attachToWBSItem: false,
        properties: false,
        update: false,
        cancel: false,
        loading: {},
      });
      setShowBoqItemLinkingModal(false);
      setEditingRowValue({});
    };

    const handleBackClick = () => {
      if (showManageItemModal.step == manageWBSItemSteps.showCDB) {
        if (source == "WBSView") {
          setShowManageItemModal((prev) => ({
            ...prev,
            step: manageWBSItemSteps.showLinkedItems,
          }));
        } else {
          setShowManageItemModal((prev) => ({
            ...prev,
            status: false,
            step: null,
          }));
        }
        setSelectedCDB({});
      } else if (showManageItemModal.step == manageWBSItemSteps.showCostDatabaseItems) {
        setShowManageItemModal((prev) => ({
          ...prev,
          step: manageWBSItemSteps.showCDB,
        }));
      } else if (showManageItemModal.step == manageWBSItemSteps.showParentWBSItems) {
        setShowManageItemModal((prev) => ({
          ...prev,
          step: manageWBSItemSteps.showLinkedItems,
        }));
      }
    };
    const manageItemHeader = () => (
      <div className="flex justify-between w-full">
        {showManageItemModal.step == manageWBSItemSteps.showLinkedItems && <Text>{t("Manage Items")}</Text>}

        {[
          manageWBSItemSteps.showCDB,
          manageWBSItemSteps.showCostDatabaseItems,
          manageWBSItemSteps.showParentWBSItems,
        ].includes(showManageItemModal.step as string) && (
          <span className="flex items-center gap-2">
            <IconComponent
              className="cursor-pointer"
              name="BackwardArrow"
              width="1rem"
              height="1rem"
              onClick={handleBackClick}
            />
            {showManageItemModal.step == manageWBSItemSteps.showCDB ? t("Cost Databases") : t("Choose Item(s)")}
          </span>
        )}
      </div>
    );

    const handleAddItemFromParent = async () => {
      setShowGridLoader(true);
      const res = await contractWBSController({
        action: "getWBSItemDetails",
        wbsOriginalItemId: originalItemId!,
        contractId: contractId,
        getParentItems: true,
        contractVersionId: contractDetails.versionId,
      });
      if (res.data.status) {
        setParentWbsLinkedItems(() => res.data.data as NonNullable<WbsGetDetailsData["dataSource"]>);
      }
      setShowManageItemModal((prev) => ({
        ...prev,
        status: true,
        step: manageWBSItemSteps.showParentWBSItems,
      }));
      setShowGridLoader(false);
    };

    const addBtnTemplate = () => {
      const btnItems = [
        {
          text: "From Cost Database",
          id: "costDatabaseItem",
        },
        {
          text: "Manual Item",
          id: "manualItem",
        },
      ];
      if (source == "WBSView" && !contractDetails.parentId) {
        btnItems.unshift({
          text: "From Linked Estimate",
          id: "estimateItem",
        });
      } else if (source == "WBSView" && contractDetails.parentId) {
        btnItems.unshift({
          text: "From Parent WBS Item",
          id: "parentBoqItems",
        });
      }
      return (
        <SelectDropDown
          ref={dropDownRef}
          disabled={!getContractCRUDPermission(contractDetails, changeOrderState)}
          items={btnItems}
          select={(args: any) => toolbarClickHandler(args.item.id)}
          cssClass="e-caret-hide border-none bg-white p-0"
        >
          <ButtonComponent
            id="add"
            disabled={!getContractCRUDPermission(contractDetails, changeOrderState)}
            buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          >
            <span className="flex items-center gap-1">
              <IconComponent name="add" width="1rem" height="1rem" />
              <Text>{t("Add Items")}</Text>
              <IconComponent name="arrowDownSm" width="1rem" height="1rem" />
            </span>
          </ButtonComponent>
        </SelectDropDown>
      );
    };
    const addChildBtnTemplate = () => {
      const btnItems = [
        {
          text: "From Cost Database",
          id: "childCostDatabaseItem",
        },
        {
          text: "Manual Item",
          id: "childManualItem",
        },
      ];
      if (source == "WBSView" && !contractDetails.parentId) {
        btnItems.unshift({
          text: "From Linked Estimate",
          id: "childEstimateItem",
        });
      }
      return (
        <SelectDropDown
          ref={dropDownRef}
          disabled={!getContractCRUDPermission(contractDetails, changeOrderState)}
          items={btnItems}
          select={(args: any) => toolbarClickHandler(args.item.id)}
          cssClass="e-caret-hide border-none bg-white p-0"
        >
          <ButtonComponent
            id="addChild"
            disabled={!getContractCRUDPermission(contractDetails, changeOrderState)}
            buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
          >
            <span className="flex items-center gap-1">
              <IconComponent name="add" width="1rem" height="1rem" />
              <Text>{t("Add Child Items")}</Text>
              <IconComponent name="arrowDownSm" width="1rem" height="1rem" />
            </span>
          </ButtonComponent>
        </SelectDropDown>
      );
    };
    const toolbarOptions = [
      {
        id: "add",
        disabled: !toolBarBtnState.add,
        template: addBtnTemplate,
      },
      {
        id: "addChild",
        disabled: !toolBarBtnState.add_child,
        template: addChildBtnTemplate,
      },

      {
        id: "edit",
        name: "Edit",
        prefixIcon: "editProfile",
        disabled: !toolBarBtnState.edit,
      },
      {
        id: "delete",
        name: "Delete",
        prefixIcon: "delete",
        disabled: !toolBarBtnState.delete,
      },
      ...(parentContract
        ? []
        : [
            {
              id: "changeType",
              name: "Change Type",
              prefixIcon: "changeType",
              disabled: !toolBarBtnState.changeType,
            },
          ]),
      ...(source == "BoqView"
        ? [
            {
              name: "Assign To WBS",
              id: "attachToWBSItem",
              prefixIcon: "smallAttachmentIcon",
              disabled: !toolBarBtnState.attachToWBSItem,
            },
          ]
        : []),
      // {
      //   id: "wrap_text",
      //   name: "Wrap",
      //   template: () => wrapTextButtonTemplate(wrapTextState),
      // },
      {
        name: t("Update"),
        prefixIcon: "Update",
        id: "update",
        loading: toolBarBtnState?.loading?.update,
        disabled: !toolBarBtnState.update,
      },
      {
        name: t("Cancel"),
        prefixIcon: "cross",
        id: "cancel",
        disabled: !toolBarBtnState.cancel,
      },
      {
        name: t("ExpandAll"),
        prefixIcon: "Expand",
        id: "expandAll",
      },
      {
        name: t("CollapseAll"),
        prefixIcon: "Collapse",
        id: "collapseAll",
      },
      ...(source == "BoqView"
        ? [
            {
              id: "properties",
              name: "Properties",
              disabled: !toolBarBtnState.properties,
            },
          ]
        : []),
    ];

    const selectionHandler = () => {
      if (editModeRef?.current?.action) {
        setToolBarBtnState((prev) => ({
          ...prev,
          add: false,
          add_child: false,
          properties: false,
          changeType: false,
          edit: false,
          delete: false,
          update: true,
          cancel: true,
        }));
        return;
      }
      const totalRowsSelected = attachedItemRef.current?.dataView?.getAllSelectedItems();
      const noOfRowsSelected = totalRowsSelected?.length;
      if (manageLinkBtnState) {
        manageLinkBtnState(noOfRowsSelected > 0);
      }
      if (showOnlyGrid) {
        return;
      }
      if (!getContractCRUDPermission(contractDetails, changeOrderState)) {
        if (setShowDetailsSideBar) {
          setShowDetailsSideBar({ status: false, selectedItem: {} });
        }
        setToolBarBtnState((prev) => ({
          ...prev,
          properties: noOfRowsSelected == 1 && !setShowDetailsSideBar,
        }));
      } else if (showManageItemModal.step === manageWBSItemSteps.showLinkedItems || source == "BoqView") {
        let enableAssignBtn = true;
        let isAnyOneManualItemPresent = false;
        totalRowsSelected?.map((item: any) => {
          if (!item?.isOrphanItem) {
            enableAssignBtn = false;
          }
          if (item?.type == "MANUAL") {
            isAnyOneManualItemPresent = true;
          }
        });
        if (setShowDetailsSideBar) {
          setShowDetailsSideBar({ status: false, selectedItem: {} });
        }
        setToolBarBtnState((prev) => ({
          ...prev,
          delete: noOfRowsSelected > 0,
          edit: noOfRowsSelected == 1,
          add_child: noOfRowsSelected == 1,
          changeType: noOfRowsSelected == 1 && !isAnyOneManualItemPresent,
          attachToWBSItem: noOfRowsSelected > 0 && enableAssignBtn,
          properties: noOfRowsSelected == 1 && !setShowDetailsSideBar,
        }));
      } else if (showManageItemModal.step === manageWBSItemSteps.showParentWBSItems) {
        if (noOfRowsSelected > 0) {
          let btnState = true;
          totalRowsSelected?.map((item: any) => {
            if (item?.isAlreadyAddedInThisContract) {
              btnState = false;
            }
          });
          setBtnState(btnState);
        } else {
          setBtnState(false);
        }
      }
    };

    function itemTypeTemplate(_row: number, _cell: number, _value: any, _columnDef: unknown, args: any) {
      if (args.type == "DSR") {
        return "Cost Database Item";
      }
      if (args.type == "ESTIMATE") {
        return "Linked Estimate Item";
      }
      if (args.type == "MANUAL") {
        return "Manual Item";
      }
      return "";
    }

    const editTemplate = ({ args, updatedColumn }: any) => {
      if (updatedColumn.field == "type") {
        return itemTypeTemplate(0, 0, null, null, { type: args.type });
      }
      // else if (updatedColumn.field == 'availableQuantity') {
      //     return Number((args.quantity - args.availableQuantity).toFixed(2))??"";
      // }
      if (["wbsItems", "availableQuantity"].includes(updatedColumn.field)) {
        return "";
      }
      return args[updatedColumn.field] || "";
    };

    function HSN_SAC_EditTemplate({ args, updatedColumn }: any) {
      const { itemId, HSN_SAC } = args;
      if (itemId && contractDetails.parentId) {
        return HSN_SAC;
      }
      return (
        <TextFieldComponent
          type="text"
          placeholder={t("Enter HSN_SAC No")}
          defaultValue={HSN_SAC}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setEditingRowValue((prev) => ({
              ...prev,
              HSN_SAC: e.target.value,
            }));
          }}
          id={_.get(updatedColumn, "field")}
          name={_.get(updatedColumn, "field")}
        />
      );
    }
    const descEditTemplate = ({ args, updatedColumn }: any) => {
      const { itemId, type, description } = args;

      if (type == "DSR" || type == "ESTIMATE" || (contractDetails.parentId && itemId)) {
        return description;
      }
      return (
        <TextFieldComponent
          type="text"
          placeholder={t("Enter Description")}
          defaultValue={description}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setEditingRowValue((prev) => ({
              ...prev,
              description: e.target.value,
            }));
          }}
          id={_.get(updatedColumn, "field")}
          name={_.get(updatedColumn, "field")}
        />
      );
    };

    function unitEditTemplate({ args }: any) {
      const { itemId, hasChild, purchaseUnit = {}, type } = args;

      if (type == "DSR" || type == "ESTIMATE" || hasChild || (contractDetails.parentId && itemId)) {
        return _.get(purchaseUnit, "name");
      }
      return (
        <SelectDropDown
          placeholder={_.get(purchaseUnit, "name", "Select Unit")}
          onChange={(newValue: any) => {
            setEditingRowValue((prev) => ({
              ...prev,
              purchaseUnit: {
                id: newValue._id,
                name: newValue.name,
              },
            }));
          }}
          buttonType={BUTTON_TYPES.BORDER_BUTTON}
          fields={{
            text: "nameWithSymbol",
            value: "_id",
          }}
          options={purchaseUnitDataSourceRef.current}
          buttonWidth="100%"
          popperWidth={300}
        />
      );
    }
    function rateEditTemplate({ args, updatedColumn }: any) {
      const { itemId, hasChild, rate, type, isPresentInLockedChildContract } = args;
      if (type == "DSR" || type == "ESTIMATE" || hasChild || (contractDetails.parentId && itemId)) {
        return rate;
      } else if ((changeOrderState.isEnabled || isPresentInLockedChildContract) && itemId) {
        return (
          <div className="flex items-center gap-3">
            {rate}
            <IconComponent
              className="cursor-pointer"
              name="details"
              width="1.5rem"
              height="1.5rem"
              position="top"
              toolTipContent={t(
                "Rate is editable neither in change order mode nor when the item is present in locked child contract",
              )}
            />
          </div>
        );
      }
      return (
        <TextFieldComponent
          onChange={(args: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setEditingRowValue((prev) => ({
              ...prev,
              rate: Number(args.target.value),
            }));
          }}
          defaultValue={rate}
          placeholder={t("Enter Rate")}
          name={_.get(updatedColumn, "field")}
          id={_.get(updatedColumn, "field")}
          slotProps={{
            htmlInput: {
              min: 0,
            },
          }}
          type="number"
          focused
        />
      );
    }
    function quantityTemplate(args: any, field: any) {
      if (args.hasChild) {
        return "";
      }
      return args[field] ? Number(args[field].toFixed(2)) : 0;
    }
    function amountTemplate(args: any, field: any) {
      let value = 0;
      if (args.hasChild) {
        const totalAmount = getTotal(args.childRecords, field);
        value = Number.parseFloat(totalAmount.toFixed(2));
      } else {
        value = args[field] ? Number.parseFloat(args[field].toFixed(2)) : 0;
      }
      if (contractDetails?.configuration?.showPercentageValues) {
        const container = document.createElement("div");
        const root = createRoot(container);
        const percentageVal =
          contractDetails?.budgetAmount === 0 ? 0 : (value * 100) / (contractDetails?.budgetAmount ?? 1);
        const finalVal = Number.parseFloat(percentageVal.toFixed(2));
        root.render(
          <div className="flex flex-col gap-2">
            <span>{value}</span>
            <span className="text-system_colour_48">{`${finalVal}%`}</span>
          </div>,
        );
        return container;
      } else {
        return value;
      }
    }

    const handleBoqBreakUpClick = async ({
      wbsOriginalItemId,
      itemId,
      contractId,
    }: {
      wbsOriginalItemId?: string;
      itemId?: string;
      contractId: string;
    }) => {
      const res = await getItemBreakUpDetails({
        source: "wbsBoqItem",
        contractId,
        wbsOriginalItemId,
        itemId,
      });
      if (res.data.status) {
        setShowBoqItemBreakUp({
          status: true,
          itemDetail: res.data,
        });
      } else {
        showErrorToast(SOMETHING_WENT_WRONG);
      }
    };

    function assignedQuantityTemplate(args: any) {
      if (args.hasChild) {
        return "";
      }
      const assignedQuantity = Number((args.revisedQuantity - args.availableQuantity).toFixed(2));

      const container = document.createElement("div");
      const root = createRoot(container);

      if (!assignedQuantity) {
        return 0;
      }
      root.render(
        <div className="flex items-center justify-between">
          {assignedQuantity}
          <IconComponent
            onClick={() =>
              handleBoqBreakUpClick({
                wbsOriginalItemId: args.wbsOriginalItemId,
                itemId: args.itemId,
                contractId,
              })
            }
            className="cursor-pointer"
            name="details"
            width="1.5rem"
            height="1.5rem"
          />
        </div>,
      );
      return container;
    }

    function quantityEditTemplate({ args, updatedColumn }: any) {
      const {
        hasChild,
        quantity,
        revisedQuantity,
        type,
        availableQuantityInParent,
        availableQuantity,
        isAlreadyAddedInThisContract,
        availableQuantityInParentEstimate = 0,
      } = args;

      if (hasChild) {
        return "";
      }
      let max: number | undefined;
      const min = revisedQuantity - (availableQuantity ?? 0) || 0;
      if (contractDetails.parentId) {
        max = availableQuantityInParent + revisedQuantity;
      } else if (type == "ESTIMATE" && contractDetails.parentId == null) {
        max = availableQuantityInParentEstimate + revisedQuantity;
      }
      if (updatedColumn.field == "quantity" && changeOrderState.isEnabled) {
        return quantity;
      }
      if (updatedColumn.field == "revisedQuantity" && !changeOrderState.isEnabled) {
        return revisedQuantity;
      }
      const fieldName = changeOrderState.isEnabled ? "revisedQuantity" : "quantity";
      return (
        <TextFieldComponent
          onChange={(args: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
            setEditingRowValue((prev) => ({
              ...prev,
              [fieldName]: Number(args.target.value),
            }));
          }}
          disabled={isAlreadyAddedInThisContract}
          defaultValue={parseFloat(revisedQuantity)}
          placeholder={t("Enter Quantity")}
          name={_.get(updatedColumn, "field")}
          id={_.get(updatedColumn, "field")}
          slotProps={{
            htmlInput: {
              min,
              max,
            },
          }}
          type="number"
          focused
        />
      );
    }
    const handleQuantityChange = ({
      event,
      itemId,
      wbsOriginalItemId,
      progressUpdateId,
      inspectionId,
    }: {
      event: { target: { value: string } };
      itemId: string;
      wbsOriginalItemId?: string;
      progressUpdateId?: string;
      inspectionId?: string;
      uniqueId?: string;
    }) => {
      const quantity = Number(event.target.value.replace(/,/g, ""));

      if (getCustomData) {
        getCustomData({
          itemId,
          quantity,
          wbsOriginalItemId,
          progressUpdateId,
          inspectionId,
        });
      } else {
        wbsBoqItemsCustomQuantity.current = {
          ...wbsBoqItemsCustomQuantity.current,
          [itemId]: quantity,
        };
      }
    };

    const linkedQuantityTemplate = (args: any) => {
      const {
        wbsOriginalItemId,
        hasChild,
        availableQuantity,
        isAlreadyAddedInThisContract,
        itemId,
        isAlreadyLinkedWithThisWBSItem,
        quantityInForm,
        progressUpdateId,
        inspectionId,
      } = args;
      const min = 0;
      const max = availableQuantity + (quantityInForm ?? 0);
      const value = wbsBoqItemsCustomQuantity.current[itemId] ?? quantityInForm ?? 0;
      if (hasChild) {
        return "";
      }
      const uniqueId = uuid();
      if (!isCurrentUserAllowed) {
        return value;
      }
      const container = document.createElement("div");
      const root = createRoot(container);
      root.render(
        <Box onClick={(e: React.SyntheticEvent) => e.stopPropagation()}>
          <NumericTextBoxComponent
            min={min}
            max={max}
            id={uniqueId}
            onBlur={(event: { target: { value: string } }) =>
              handleQuantityChange({
                event,
                itemId,
                wbsOriginalItemId,
                uniqueId,
                inspectionId,
                progressUpdateId,
              })
            }
            disabled={isAlreadyAddedInThisContract || isAlreadyLinkedWithThisWBSItem || !isCurrentUserAllowed}
            value={value}
            placeholder={t("Enter Quantity")}
          />
        </Box>,
      );
      return container;
    };

    function validationForAddItem({ purchaseUnit, rate, quantity, description, revisedQuantity }: any) {
      if (!quantity && quantity != 0 && !changeOrderState.isEnabled) {
        return { status: false, content: t("Please enter the quantity for the item") };
      }
      if (!revisedQuantity && revisedQuantity != 0 && changeOrderState.isEnabled) {
        return { status: false, content: t("Please enter the quantity for the item") };
      }
      if (!description) {
        return { status: false, content: t("Please enter the description for the item") };
      }

      if (!rate && rate != 0) {
        return { status: false, content: t("Please enter the rate for the item") };
      }
      if (!purchaseUnit) {
        return { status: false, content: t("Please enter the purchaseUnit for the item") };
      }

      return { status: true, content: undefined };
    }

    const addManualItem = (args: any) => {
      const { purchaseUnit, rate, quantity, description, itemLevel, HSN_SAC, revisedQuantity, parentId, parentsList } =
        args;
      const validationCheck = validationForAddItem({
        purchaseUnit,
        rate,
        quantity,
        description,
        revisedQuantity,
      });
      if (!validationCheck.status && validationCheck.content) {
        dispatch(showToastNotification({ content: validationCheck.content, type: TOAST_TYPE_WARNING }));
      } else {
        const { name, id }: any = purchaseUnit;
        const newQuantity = quantity || revisedQuantity;
        const newData: any = {
          amount: rate * Number(newQuantity),
          revisedAmount: rate * Number(newQuantity),
          quantity: Number(newQuantity),
          revisedQuantity: Number(newQuantity),
          availableQuantity: Number(newQuantity),
          billedAmount: 0,
          inspectedAmount: 0,
          usedAmount: 0,
          remainingAmount: 0,
          rate,
          description,
          HSN_SAC,
          itemLevel,
          type: "MANUAL",
          hasChild: false,
          purchaseUnit: { name, id: id },
          parentId,
          parentsList,
          itemId: new ObjectId().toHexString(),
        };
        if (parentId) {
          setNewParentIds((prev) => [...prev, parentId]);
        }
        if (changeOrderState.isEnabled) {
          newData.amount = 0;
          newData.quantity = 0;
          newData.changeOrderAmount = rate * Number(newQuantity);
          newData.changeOrderQuantity = newQuantity;
          newData.isAddedThroughChangeOrder = true;
        }
        if (source == "WBSView") {
          setGridDataSource((prev) => {
            const modifiedData = prev.map((item) => {
              if (parentId == item.itemId) {
                item.hasChild = true;
                item.rate = null;
              }
              return item;
            });
            return [newData, ...modifiedData];
          });
        } else if (source == "BoqView") {
          addItemsInBoqView({ data: [newData] });
        }
        cancelEditRecord();
      }
    };

    const addItemsInBoqView = async ({ data, wbsItemId = null }: any) => {
      const res = await contractWBSController({
        action: "manageBoqViewItems",
        actionCase: "add",
        contractId,
        data,
        wbsItemId: typeOfItemAdded.type == "Child" ? typeOfItemAdded.parentData.wbsItems[0]?._id : wbsItemId,
        parentId: typeOfItemAdded.type == "Child" ? typeOfItemAdded.parentData.itemId : null,
      });
      cancelEditRecord();
      if (res.data.status) {
        loadDetailsData();
      } else {
        dispatch(
          showToastNotification({
            content: untranslated(res.data.errorMessage),
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    };

    async function addItemsCallBack(args: any) {
      estimateItemBackBtnCallback();
      if (source == "WBSView") {
        if (typeOfItemAdded.type == "Child") {
          setNewParentIds((prev) => [...prev, typeOfItemAdded.parentData.itemId]);
        }

        const newItemIds: any = [];
        const newModifiedData = args.map((item: any) => {
          newItemIds.push(item.itemId);
          if (typeOfItemAdded.type == "Child") {
            if (!item.parentId) {
              item.parentId = typeOfItemAdded.parentData.itemId;
            }
            item.itemLevel = typeOfItemAdded.parentData.itemLevel + 1 + item.itemLevel;
            if (typeOfItemAdded.parentData.parentsList) {
              const filteredList = typeOfItemAdded.parentData.parentsList.filter((obj: any) => obj.type);
              item.parentsList.push(
                ...[
                  ...filteredList,
                  {
                    type: typeOfItemAdded.parentData.type,
                    itemId: typeOfItemAdded.parentData.itemId,
                  },
                ],
              );
            } else {
              item.parentsList.push({
                type: typeOfItemAdded.parentData.type,
                itemId: typeOfItemAdded.parentData.itemId,
              });
            }
          }
          return item;
        });

        setGridDataSource((prev) => {
          const prevModifiedData = prev.map((item) => {
            if (typeOfItemAdded?.parentData?.itemId == item.itemId) {
              item.hasChild = true;
              item.rate = null;
            }
            return item;
          });

          const overRiddenItems = prevModifiedData.filter((item) => !newItemIds.includes(item.itemId));
          return [...newModifiedData, ...overRiddenItems];
        });
      } else if (source == "BoqView") {
        addItemsInBoqView({ data: args });
      }
    }
    const unitTemplate = (data: any, value: any, a: any, b: any, args: any) => {
      const { hasChild, purchaseUnit } = args;
      if (hasChild) {
        return null;
      }

      return _.get(purchaseUnit, "name");
    };

    function getSerialForParentInPreviewMode(parentId: any, level: any) {
      if (level < 0) {
        return null;
      }
      const records = attachedItemRef.current.dataView.items;
      const parentRecord = records.find((record: any) => record.itemId === parentId);

      if (!parentRecord) {
        return null;
      }

      const { parentId: grandParentId, serial, numberingSystem } = parentRecord;

      let result = `${serial}`;

      result = getSymbolForNumber(serial, numberingSystem, 0);

      const grandParentSerial = getSerialForParentInPreviewMode(grandParentId, level - 1);

      if (grandParentSerial) {
        result = `${grandParentSerial}.${result}`;
      }

      return result;
    }

    const serialTemplate = (args: any) => {
      const { serial, parentId, itemLevel, numberingSystem } = args;
      let result = serial;
      if (!serial) {
        return "";
      }
      result = getSymbolForNumber(serial, numberingSystem, 0);

      const parentSerial = getSerialForParentInPreviewMode(parentId, itemLevel - 1);
      if (portalData?.frontendUrl?.includes("rustomjee")) {
        return parentSerial ? `${parentSerial}0.${result}0` : `${result}0`;
      }
      return parentSerial ? `${parentSerial}.${result}` : `${result}`;
    };

    const handleInfoClick = (e: any, args: any) => {
      e.stopPropagation();
      infoClickCallBack?.(args);
    };

    const detailTemplate = (data: any, value: any, a: any, b: any, args: any) => {
      if (args.hasChild) {
        return "";
      }
      const container = document.createElement("div");
      const root = createRoot(container);
      root.render(
        <div className="flex items-center">
          <IconComponent
            onClick={(e: React.MouseEvent) => handleInfoClick(e, args)}
            name="details"
            width="1.5rem"
            height="1.5rem"
            className="cursor-pointer"
          />
        </div>,
      );
    };
    const wbsItemsTemplate = (data: any, value: any, a: any, b: any, args: any) => {
      let names = [];
      if (Array.isArray(args.wbsItems)) {
        names = args.wbsItems?.map((item: any) => item.code) || [];
      }
      return names.join(",");
    };

    const handleRemarkChange = ({ event, args }: { event: { target: { value: string } }; args: WbsGridRowLoose }) => {
      if (getCustomData) {
        getCustomData({
          itemId: args.itemId,
          remark: event.target.value,
          wbsOriginalItemId: args.wbsOriginalItemId,
          progressUpdateId: args.progressUpdateId,
          inspectionId: args.inspectionId,
        });
      }
    };

    const remarksTemplate = (args: any) => {
      if (args.hasChild) {
        return "";
      }
      if (!isCurrentUserAllowed) {
        return args.remark ?? "";
      }
      const container = document.createElement("div");
      const root = createRoot(container);
      root.render(
        <TextFieldComponent
          type="text"
          placeholder={t("Remark")}
          value={args.remark ?? ""}
          id={args.uniqueId}
          onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
            handleRemarkChange({ event, args })
          }
          onClick={(e: React.SyntheticEvent) => e.stopPropagation()}
        />,
      );
      return container;
    };

    const gridColumns = getGridColumns({
      source,
      showManageItemModal,
      editTemplate,
      itemTypeTemplate,
      HSN_SAC_EditTemplate,
      descEditTemplate,
      rateEditTemplate,
      unitEditTemplate,
      unitTemplate,
      quantityEditTemplate,
      changeOrderState,
      quantityTemplate,
      linkedQuantityTemplate,
      amountTemplate,
      assignedQuantityTemplate,
      detailTemplate,
      showInfoColumn,
      showDetailedColumns: contractDetails.lockData?.isLocked || contractDetails.isAnyOneChildContractLocked,
      wbsItemsTemplate,
      allowCheckBoxSelection,
      showQuantityInputBox,
      remarksTemplate,
      showRemarksColumn,
      isRustomjeePortal,
      Formatters,
    });

    useEffect(() => {
      setColumnDefinitions(() => [...gridColumns]);
    }, []);

    const titleFormatter = (data: any, value: any, a: any, b: any, args: any) => serialTemplate(args);

    const getBoqItemsOfWBSItems = () => {
      let toolbar: any = toolbarOptions;
      if (showOnlyGrid) {
        toolbar = null;
      }
      if (showManageItemModal.step == manageWBSItemSteps.showParentWBSItems) {
        toolbar = null;
      }
      return (
        <SlickGrid
          ref={attachedItemRef}
          columnDefinitions={columnDefinitions}
          treeGrid
          enableWrapText={isWrapTextActive}
          setEnableWrapText={setIsWrapTextActive}
          disableTreeCollapseOnDataChange
          disableCustomSorting
          titleFormatter={titleFormatter}
          treeColIndex={1}
          initialSortColumnId="createdDate"
          levelPropName="itemLevel"
          initialSortDirection="ASC"
          disabledIds={disabledRows}
          gridOptions={{
            enableSorting: true,
            enableAutoResize: true,
            showHeaderRow: false,
          }}
          allowPagination={false}
          idMapping={idMapper.id}
          disableChildDataFetch
          enableCheckboxSelector={allowCheckBoxSelection}
          hasChildMapping="hasChild"
          parentIdMapping={idMapper.parentId}
          onSelectedRowIdsChanged={selectionHandler}
          toolbar={toolbar}
          isEditMode={!!editingRowValue.action}
          toolbarClickHandler={toolbarClickHandler}
          dataset={
            showManageItemModal.step == manageWBSItemSteps.showParentWBSItems ? parentWbsLinkedItems : gridDataSource
          }
          enableFiltering={true}
          enableFilteringOption
          enableSortingOption
          showLoader={showGridLoader}
          enableGroupingOption
          enableColumnChooser
        />
      );
    };

    const getLinkedItems = () => (
      <div className="flex flex-col gap-5 h-full w-full">
        {contractDetails.parentId && !showOnlyGrid && source == "WBSView" && (
          <span className="text-sm h-3 text-system_colour_12 opacity-70">
            <Text sx={{ whiteSpace: "normal" }}>
              {t(
                "NOTE - Items which are not present in parent contract and are added here will also be added in all parent contracts",
              )}
            </Text>
          </span>
        )}
        {getBoqItemsOfWBSItems()}
        {!showOnlyGrid && (
          <div className={`${source == "BoqView" ? "p-3" : ""} w-full flex pe-10 justify-between`}>
            <Text className="font-semibold">{t("Total Amount of Linked Items")} :</Text>
            <div>{`${currencyDetails.symbolDetail?.name} ${totalAmountLinked ?? 0}`}</div>
          </div>
        )}
      </div>
    );
    const getParentItems = () => <div className="flex flex-col gap-5 h-full w-full">{getBoqItemsOfWBSItems()}</div>;

    const setBtnState = (state: any) => {
      setShowManageItemModal((prev) => {
        if (prev.step === manageWBSItemSteps.showCDB) {
          return {
            ...prev,
            metaData: {
              ...prev.metaData,
              isNextEnabled: state,
            },
          };
        }
        if (prev.step === manageWBSItemSteps.showParentWBSItems) {
          return {
            ...prev,
            metaData: {
              ...prev.metaData,
              isAddParentWbsItemsBtnEnabled: state,
            },
          };
        }

        return {
          ...prev,
          metaData: {
            ...prev.metaData,
            isLinkCDBItemsBtnEnabled: state,
          },
        };
      });
    };

    const getCostDatabaseList = () => {
      return (
        <CostDatabases
          allowSingleSelection
          dsrQuery={{
            projectId: params.projectId,
            publishedVersion: true,
            params: {
              projectId: params.projectId,
              publishedVersion: true,
            },
          }}
          selectedCDB={selectedCDB}
          setBtnState={setBtnState}
          showOnlyGrid
          setSelectedCDB={setSelectedCDB}
        />
      );
    };

    const manageItemContent = () => (
      <div className="h-full">
        {showManageItemModal.step == manageWBSItemSteps.showLinkedItems && getLinkedItems()}
        {showManageItemModal.step == manageWBSItemSteps.showCDB && getCostDatabaseList()}
        {showManageItemModal.step == manageWBSItemSteps.showCostDatabaseItems && (
          <div className="overflow-auto flex gap-4 flex-col w-full h-full">
            <span className="ps-5"> {`Cost Database : ${selectedCDB.name}`} </span>
            <EstimateDsrItemsGridNew
              ref={CDBItemsRef}
              setBtnState={setBtnState}
              enableCheckboxSelector
              currencyData={selectedCDB.currency as EstimateCurrency}
              dsrId={selectedCDB._id}
              dsrVersionId={selectedCDB.costDBversionId}
              source={itemListSources.CONTRACT_CDB}
              wbsOriginalItemId={originalItemId}
              contractId={contractId}
              contractVersionId={contractDetails.versionId}
            />
          </div>
        )}
        {showManageItemModal.step == manageWBSItemSteps.showParentWBSItems && getParentItems()}
      </div>
    );

    const saveWBSItems = async ({ addAmountToWBSItem = false }) => {
      setShowGridLoader(true);
      const res = await contractWBSController({
        action: "saveWBSItemDetails",
        wbsOriginalItemId: originalItemId!,
        data: gridDataSource,
        contractId,
        deletedRows,
        wbsItemId: _id!,
        addAmountToWBSItem,
        parentIds: newParentIds,
      });
      if (res.data.status) {
        dispatch(
          showToastNotification({
            content: t("Successfully saved"),
            type: TOAST_TYPE_SUCCESS,
          }),
        );
        cancelManageItem();
        manageItemSuccessCallBack?.();
      } else {
        showErrorToast(res.data.errorMessage);
      }
      setShowGridLoader(false);
    };

    const handleSaveItemsClick = async () => {
      if (totalAmountLinked > wbsItemDetail.revisedAmount) {
        setShowWarningModal({ status: true, source: "saveWBSItems" });
      } else {
        await saveWBSItems({ addAmountToWBSItem: false });
      }
    };

    const handleCDBselectNextClick = () => {
      setShowManageItemModal((prev) => ({
        ...prev,
        step: manageWBSItemSteps.showCostDatabaseItems,
      }));
    };

    const handleCDBItemsSelectAddClick = async () => {
      const selectedItems = CDBItemsRef.current.dataView
        .getAllSelectedItems()
        .filter((record: any) => record && !record.__isDummy);
      let isItemAlreadyPresent = false;
      let content = "";
      const selectedItemsArray = selectedItems.map((item: any) => {
        if (item.isAlreadyLinkedWithThisWBSItem) {
          isItemAlreadyPresent = true;
          content = "One of the selected Item(s) is already attached with this wbs item";
        }
        if (item.isAlreadyAddedInThisContract) {
          isItemAlreadyPresent = true;
          content = "One of the selected Item(s) is already attached in this contract";
        }
        return { itemId: item.itemId, parentsList: item.parentsList };
      });

      if (isItemAlreadyPresent) {
        showErrorToast(content);
      } else {
        const res = await contractWBSController({
          selectedItemsArray,
          action: "getAlFamilyOfCDBItems",
          costDatabaseVersionId: selectedCDB.costDBversionId!,
        });
        if (res.data.status) {
          const dataSource =
            res.data.result?.map((item: any) => {
              const data = {
                ...item,
                rate: item.hasChild ? null : item.rate,
                purchaseUnit: item.hasChild ? null : item.purchaseUnit,
                parentId: item.parentId == "0" ? null : item.parentId,
                quantity: 0,
                amount: 0,
                revisedQuantity: 0,
                revisedAmount: 0,
                billedAmount: 0,
                inspectedAmount: 0,
                usedAmount: 0,
                remainingAmount: 0,
              };
              const selectedItem: any = selectedItemsInMainGrid[0];
              if (selectedItem && typeOfItemAdded.type === "Child") {
                if (!data.parentId) {
                  data.parentId = selectedItem.itemId;
                }
                data.itemLevel = selectedItem.itemLevel + 1 + (item.itemLevel ?? 0);
                if (selectedItem.parentsList) {
                  const filteredList = selectedItem.parentsList.filter((obj: any) => obj.type);
                  data.parentsList.push(
                    ...[
                      ...filteredList,
                      {
                        type: selectedItem.type,
                        itemId: selectedItem.itemId,
                      },
                    ],
                  );
                } else {
                  data.parentsList.push({
                    type: selectedItem.type,
                    itemId: selectedItem.itemId,
                  });
                }
              }
              if (changeOrderState.isEnabled) {
                data.isAddedThroughChangeOrder = true;
              }
              return data;
            }) ?? [];

          const childSerialMapper: any = {};
          const newDatasource = dataSource.map((item: any) => {
            if (item.parentId) {
              if (childSerialMapper[item.parentId]) {
                item.serial = childSerialMapper[item.parentId] + 1;
                childSerialMapper[item.parentId] = childSerialMapper[item.parentId] + 1;
              } else {
                item.serial = 1;
                childSerialMapper[item.parentId] = 1;
              }
            }
            return item;
          });
          if (source == "BoqView") {
            addItemsInBoqView({ data: newDatasource });
            setShowManageItemModal(() => initialManageObj);
          } else if (source == "WBSView") {
            setShowManageItemModal((prev) => ({
              ...prev,
              step: manageWBSItemSteps.showLinkedItems,
            }));
            const newItemIds = newDatasource.map((item: any) => item.itemId);
            const selectedItem: any = selectedItemsInMainGrid[0];
            if (selectedItem && typeOfItemAdded.type === "Child") {
              setNewParentIds((prev) => [...prev, selectedItem?.itemId]);
            }
            setGridDataSource((prev) => {
              const overRiddenItems = (prev ?? [])
                .filter((item) => item != null)
                .map((item) => {
                  if (item.itemId == selectedItem?.itemId) {
                    item.hasChild = true;
                  }
                  return item;
                })
                .filter((item) => !newItemIds.includes(item.itemId));
              return [...newDatasource, ...overRiddenItems];
            });
          }
          setSelectedCDB({});
        }
      }
    };

    const handleAddParentWbsItemsClick = () => {
      const selectedItemsFromParent = attachedItemRef.current?.dataView?.getAllSelectedItems();
      const allItemIdToAdd: any = [];
      selectedItemsFromParent.map((item: any) => {
        allItemIdToAdd.push(item.itemId);
        if (item.parentsList) {
          item.parentsList.map((pItem: any) => {
            if (pItem.itemId != "0") {
              allItemIdToAdd.push(pItem.itemId);
            }
          });
        }
        [...parentWbsLinkedItems].map((data: any) => {
          if (data.parentsList) {
            const pData = data.parentsList.find((pItem: any) => pItem.itemId == item.itemId);
            if (pData) {
              allItemIdToAdd.push(data.itemId);
            }
          }
        });
      });
      const allDataToAdd = [...parentWbsLinkedItems].filter((item: any) => allItemIdToAdd.includes(item.itemId));

      const childSerialMapper: any = {};
      const dataSource = allDataToAdd.map((item: any) => {
        const data: any = {
          amount: item.hasChild ? null : item.rate * (wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0),
          availableQuantity: wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0,
          description: item.description,
          availableQuantityInParent: item.availableQuantity,
          hasChild: item.hasChild,
          parentId: item.parentId,
          rate: item.hasChild ? null : item.rate,
          quantity: item.hasChild ? null : (wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0),
          purchaseUnit: item.hasChild ? null : item.purchaseUnit,
          type: item.type,
          measurementUnit: item.hasChild ? null : item.measurementUnit,
          code: item.code,
          itemId: item.itemId,
          isExpanded: false,
          isAddedFromParentContract: true,
          serial: item.parentId == null ? null : item.serial,
          HSN_SAC: item.HSN_SAC,
          revisedAmount: item.hasChild ? null : item.rate * (wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0),
          revisedQuantity: item.hasChild ? null : (wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0),
        };
        if (changeOrderState.isEnabled) {
          data.quantity = 0;
          data.amount = 0;
          data.changeOrderQuantity = item.hasChild ? null : (wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0);
          data.changeOrderAmount = item.hasChild
            ? null
            : item.rate * (wbsBoqItemsCustomQuantity.current[item.itemId] ?? 0);
          data.isAddedThroughChangeOrder = true;
        }
        if (item.type == "DSR") {
          data.costDatabaseVersionId = item.costDatabaseVersionId;
          data.costDatabaseId = item.costDatabaseId;
          data.rateAnalysis = item.rateAnalysis;
          data.itemLevel = item.itemLevel;
          data.parentsList = item.parentsList;
        } else if (item.type == "ESTIMATE") {
          data.itemLevel = item.itemLevel;
          data.parentsList = item.parentsList;
          data.estimateId = item.estimateId;
          data.estimateVersionId = item.estimateVersionId;
          delete data.availableQuantityInParentEstimate;
        }

        if (item.parentId) {
          if (childSerialMapper[item.parentId]) {
            data.serial = childSerialMapper[item.parentId] + 1;
            childSerialMapper[item.parentId] = childSerialMapper[item.parentId] + 1;
          } else {
            data.serial = 1;
            childSerialMapper[item.parentId] = 1;
          }
        }
        return data;
      });
      const newItemIds = dataSource.map((item: any) => item.itemId);
      setGridDataSource((prev) => {
        const overRiddenItems = prev
          .map((item) => {
            if (item.itemId == typeOfItemAdded.parentData.itemId) {
              item.hasChild = true;
            }
            return item;
          })
          .filter((item) => !newItemIds.includes(item.itemId));
        return [...dataSource, ...overRiddenItems];
      });

      setShowManageItemModal((prev) => ({
        ...prev,
        step: manageWBSItemSteps.showLinkedItems,
      }));
    };

    const manageItemFooter = () => (
      <div className=" flex gap-4">
        {showManageItemModal.step == manageWBSItemSteps.showLinkedItems &&
          getContractCRUDPermission(contractDetails, changeOrderState) && (
            <ButtonComponent
              loading={showGridLoader}
              onClick={handleSaveItemsClick}
              buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            >
              <Text>{t("Save")}</Text>
            </ButtonComponent>
          )}

        {showManageItemModal.step == manageWBSItemSteps.showCDB && (
          <ButtonComponent
            onClick={handleCDBselectNextClick}
            disabled={!_.get(showManageItemModal, "metaData.isNextEnabled")}
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          >
            <Text>{t("Next")}</Text>
          </ButtonComponent>
        )}

        {showManageItemModal.step == manageWBSItemSteps.showCostDatabaseItems && (
          <ButtonComponent
            onClick={handleCDBItemsSelectAddClick}
            disabled={!_.get(showManageItemModal, "metaData.isLinkCDBItemsBtnEnabled")}
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          >
            <Text>{t("Add")}</Text>
          </ButtonComponent>
        )}

        {showManageItemModal.step == manageWBSItemSteps.showParentWBSItems && (
          <ButtonComponent
            onClick={handleAddParentWbsItemsClick}
            disabled={!_.get(showManageItemModal, "metaData.isAddParentWbsItemsBtnEnabled")}
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
          >
            <Text>{t("Add")}</Text>
          </ButtonComponent>
        )}

        <ButtonComponent onClick={cancelManageItem} buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}>
          <Text>{t("Cancel")}</Text>
        </ButtonComponent>
      </div>
    );

    const estimateItemBackBtnCallback = () => {
      if (source == "WBSView") {
        setShowManageItemModal((prev) => ({
          ...prev,
          status: true,
          step: manageWBSItemSteps.showLinkedItems,
        }));
      }
      setShowBoqItemLinkingModal(false);
    };

    const setSelectedWBSItemsToAttach = async ({ itemId, boqAvailableAmount }: any) => {
      const selectedBoqItems = attachedItemRef.current?.dataView?.getAllSelectedItems();
      const boqItemIds = selectedBoqItems.map((item: { itemId: string }) => item.itemId).filter(Boolean);

      let totalAmountOfSelectedItems = 0;
      selectedBoqItems.map((item: any) => {
        if (item.hasChild) {
          const amount = getTotal(item.childRecords, "revisedAmount");
          totalAmountOfSelectedItems = totalAmountOfSelectedItems + amount;
        } else {
          totalAmountOfSelectedItems = totalAmountOfSelectedItems + item.revisedAmount;
        }
      });

      if (totalAmountOfSelectedItems > boqAvailableAmount) {
        dispatch(
          showToastNotification({
            content: t(
              "Available BOQ amount of the selected WBS item is less than selected boq items and its children",
            ),
            type: TOAST_TYPE_WARNING,
          }),
        );
      } else {
        const res = await contractWBSController({
          action: "manageBoqViewItems",
          actionCase: "assign",
          contractId,
          data: boqItemIds,
          wbsItemId: itemId,
        });
        if (res.data.status) {
          setShowAssignWBSModal(false);
          loadDetailsData();
        } else {
          showErrorToast(res.data.errorMessage);
        }
      }
    };

    const hideWarningModal = () => {
      setShowWarningModal({ status: false, source: "" });
    };
    const getWarningModal = () => {
      const source = showWarningModal.source;
      let btnText;
      let contentTxt;
      let headerText;
      let callBackFun: any;
      switch (source) {
        case "saveWBSItems":
          btnText = "Add";
          contentTxt =
            "Attached Boq items Amount is greater than the allotted budget amount to this WBS item, click the add button below to add the difference amount to this WBS item as well or close the popup to cancel";
          headerText = t("Add Items");
          callBackFun = saveWBSItems;
          break;
      }
      return (
        <ModalStateDialogComponent
          footerContent={
            <div>
              <ButtonComponent
                onClick={() => callBackFun({ addAmountToWBSItem: true })}
                buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
              >
                {btnText}
              </ButtonComponent>
            </div>
          }
          width="30%"
          headerTitle={<div className="flex w-full justify-between items-center">{headerText}</div>}
          onCancel={hideWarningModal}
          isVisible={showWarningModal.status}
          modelContent={<div className="">{contentTxt} </div>}
        />
      );
    };
    return (
      <>
        {source === "BoqView" || showOnlyGrid ? (
          <div className="w-full h-full overflow-auto flex">{getLinkedItems()}</div>
        ) : (
          <div className="w-full h-full p-5 flex-col overflow-auto flex">
            <span className="flex flex-col border-b-2 pb-5 gap-5 w-full border-button_light ">
              <span className="border flex w-fit rounded-sm p-1 border-gray-500">{code}</span>
              <span>{description}</span>
            </span>
            <span className="h-full w-full flex overflow-auto">{getItemDataAcc()}</span>
          </div>
        )}
        {showBoqItemLinkingModal && (
          <LinkBoqItems
            changeOrderState={changeOrderState}
            wbsOriginalItemId={originalItemId}
            addItemsCallBack={addItemsCallBack}
            showBackBtn
            backBtnCallback={estimateItemBackBtnCallback}
            source={source}
            contractId={contractId}
            hideBoqItemsModal={hideBoqItemsLinkingModal}
          />
        )}
        {showManageItemModal.status && (
          <ModalStateDialogComponent
            allowModalPadding={false}
            footerContent={manageItemFooter()}
            width="80%"
            height="80%"
            headerTitle={manageItemHeader()}
            onCancel={cancelManageItem}
            isVisible
            modelContent={manageItemContent()}
          />
        )}
        {showBoqItemBreakUp.status && (
          <ItemBreakUpModal
            source="boqItem"
            itemDetails={showBoqItemBreakUp.itemDetail}
            closeModalCallBack={() =>
              setShowBoqItemBreakUp({ status: false, itemDetail: { contractForms: [], contracts: [] } })
            }
          />
        )}
        {showAssignWBSModal && (
          <LinkWBS
            allowSingleSelection
            hideLinkWbsModal={() => setShowAssignWBSModal(false)}
            setSelectedWBSItemsToAttach={setSelectedWBSItemsToAttach}
            parentContractId={contractDetails.parentId}
            contractId={contractId}
            wbsSource={linkWBSSources.contractWBS}
            formId={undefined}
          />
        )}
        {showWarningModal.status && getWarningModal()}
      </>
    );
  },
);
WBSItemDetails.displayName = "WBSItemDetails";
export default WBSItemDetails;
